import React from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
//import { P24ImplType, getP24ImplTypeByName } from "../../constants/P24ImplType";
import { parseMoneyMultiply100 } from "../../helpers/utils"
import { P24ImplementationType, getP24ImplementationTypeByName } from "../../constants/P24ImplementationType";


const floatRegExp = new RegExp('^[+-]?([0-9]+([.][0-9]*)?|[.][0-9]+)$')

/**
 * Formularz transakcji testowej
 */
class P24TransactionForm extends React.Component {

    state = {
        transaction: this.props.transaction,
        //wybrany typ implementacji
        selectedP24ImplementationType: P24ImplementationType.REST.name
    }

    handleSubmit = e => {
        e.preventDefault();

        //konwersujemy nasz obiekt w ten sposob, ze wlasciwosc amount jest parsowana na liczbe calkowita reprezentujaca grosze
        //let transactionConverted = { ...this.state.transaction, amount: parseFloat(parseFloat(this.state.transaction.amount).toFixed(2)) }
        //parsujemy kwote do groszy
        let transactionConverted = { ...this.state.transaction, amount: parseMoneyMultiply100(this.state.transaction.amount) }

        let p24ImplType = getP24ImplementationTypeByName(this.state.selectedP24ImplementationType);

        // ...(getAuthenticationType().isDefault ? undefined : { type: getAuthenticationType().name })
        this.props.onSubmit(p24ImplType, transactionConverted);

    };

    handleCancel = e => {
        this.props.onCancel();
    };

    handleInputChange = e => {
        const target = e.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;
        let transaction = { ...this.state.transaction, [name]: value };
        this.setState({ transaction });
    };

    handleOptionChange = e => {
        const target = e.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        // const name = target.name;

        //let p24ImplType = { ...this.state.transaction, [name]: value };
        this.setState({ selectedP24ImplementationType: value });

    };

    handleDecimalInputChange = e => {
        const target = e.target;
        const value = target.type === "checkbox" ? target.checked : target.value;
        const name = target.name;

        //nie pozwalamy na pusty string
        //value === '' ||
        if (floatRegExp.test(value)) {
            //przechodzi walidacje regex

            //obcinamy do dwoch miejsc po przecinku
            //const floatValue = parseFloat(value);
            //const floatValue2Decimals = floatValue.toFixed(2);

            let transaction = { ...this.state.transaction, [name]: value };
            this.setState({ transaction });
        }
    }

    render() {
        return (
            <div className="w3-card-4">
                <div className="w3-container w3-theme">
                    <h2 className="w3-center">{this.props.title}</h2>
                </div>

                <div className="w3-row-padding">
                    <div className="w3-col s4">
                        <input
                            className="w3-input"
                            type="text"
                            name="restaurantId"
                            onChange={this.handleInputChange}
                            value={this.state.transaction.restaurantId}

                        ></input>
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Transaction.restaurantId"
                                defaultMessage="Restauracja"
                            />
                        </label>
                    </div>
                </div>

                <div className="w3-row-padding">

                    <div className="w3-col s6">
                        <input
                            className="w3-input"
                            type="text"
                            pattern="[a-zA-Z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*"
                            title="Nieprawidłowy adres e-mail"
                            name="email"
                            onChange={this.handleInputChange}
                            value={this.state.transaction.email}
                            required
                        />
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Transaction.email"
                                defaultMessage="Email"
                            />
                        </label>
                    </div>

                    <div className="w3-col s4">
                        <input
                            className="w3-input w3-right-align"
                            type="text"
                            name="amount"
                            onChange={this.handleDecimalInputChange}
                            value={this.state.transaction.amount}
                            maxLength="10"
                        />
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Transaction.amount"
                                defaultMessage="Amount"
                            />
                        </label>
                    </div>
                    <div className="w3-col s2">
                        <input
                            className="w3-input w3-border-0"
                            type="text"
                            name="currency"
                            onChange={this.handleInputChange}
                            value="PLN"
                            readOnly
                        ></input>
                    </div>
                </div>

                <div className="w3-row-padding">
                    <div className="w3-col s6">
                        <input
                            className="w3-input"
                            type="text"
                            name="description"
                            onChange={this.handleInputChange}
                            value={this.state.transaction.description}
                        />
                        <label className="w3-text-theme w3-small">
                            <FormattedMessage
                                id="p24Transaction.description"
                                defaultMessage="Description"
                            />
                        </label>
                    </div>
                </div>

                <div className="w3-row-padding">
                    <div className="w3-col s4">
                        <input
                            className="w3-radio"
                            type="radio"

                            onChange={this.handleOptionChange}
                            value={P24ImplementationType.REST.name}
                            checked={this.state.selectedP24ImplementationType === P24ImplementationType.REST.name}
                        />
                        <label className="w3-text-theme w3-small">
                            {P24ImplementationType.REST.displayText} (wymaga klucza do API merchanta)
                        </label>
                    </div>
                    <div className="w3-col s4">
                        <input
                            className="w3-radio"
                            type="radio"

                            onChange={this.handleOptionChange}
                            value={P24ImplementationType.FORM.name}
                            checked={this.state.selectedP24ImplementationType === P24ImplementationType.FORM.name}
                        />
                        <label className="w3-text-theme w3-small">
                            {P24ImplementationType.FORM.displayText} (wymaga CRC merchanta - bez klucza API)
                        </label>
                    </div>
                </div>

                <form className="w3-container" onSubmit={this.handleSubmit}>

                    <div className="w3-bar">
                        <button
                            className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                            type="submit"
                        >
                            {this.props.sumbitText}
                        </button>
                        <button
                            className="w3-btn w3-theme-light w3-bar-item w3-right w3-margin-right"
                            type="reset"
                            onClick={this.handleCancel}
                        >
                            {this.props.cancelText}
                        </button>
                    </div>
                </form>
            </div>
        )
    }
}

P24TransactionForm.defaultProps = {
    transaction: {
        restaurantId: 1059,
        amount: 0.01,
        email: '',
        description: 'Transakcja testowa na 1g'
    },
    cancelText: 'Anuluj',
    sumbitText: 'Zapisz'
}

P24TransactionForm.propTypes = {
    //tytul formularza
    title: PropTypes.string.isRequired,
    //dane wejsciowe obiektu do wypelnienia
    transaction: PropTypes.object.isRequired,
    //akcja zwrotna na anuluj
    onCancel: PropTypes.func.isRequired,
    //akcja zwrotna na zatwierdzenie
    onSubmit: PropTypes.func.isRequired,
    //tekst na akcji anuluj
    cancelText: PropTypes.string.isRequired,
    //tekst na akcji zapisz
    sumbitText: PropTypes.string.isRequired
}

export default P24TransactionForm